var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_92_7087)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 19.7656C15.3934 19.7656 19.7656 15.3934 19.7656 10C19.7656 4.60659 15.3934 0.234375 10 0.234375C4.60659 0.234375 0.234375 4.60659 0.234375 10C0.234375 15.3934 4.60659 19.7656 10 19.7656Z",
    fill: "url(#paint0_linear_92_7087)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M19.4839 12.3353L12.7266 5.57816C12.0686 4.94063 11.1076 4.58008 10.0021 4.58008C8.00231 4.58008 6.34785 5.74086 6.34785 7.92848L8.87817 10.4588C8.71242 10.8245 8.60742 11.2814 8.60742 11.8746V12.1534L9.34293 12.8889H8.54903V15.4202L12.556 19.427C14.2379 18.9694 15.7669 18.0707 16.9849 16.8239C18.203 15.5771 19.0657 14.0274 19.4839 12.3353Z",
    fill: "url(#paint1_linear_92_7087)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60758 11.8746C8.60758 10.2102 9.4318 9.61395 10.1164 9.11812C10.6064 8.77047 11.017 8.47312 11.017 7.88016C11.017 7.25727 10.5491 6.86527 9.99379 6.86527C9.4323 6.86527 8.90758 7.24027 8.90758 7.92848H6.34801C6.34801 5.74098 8.00246 4.58008 10.0023 4.58008C12.0832 4.58008 13.652 5.85762 13.652 7.85523C13.652 9.24465 12.876 9.8448 12.1858 10.3823C11.6375 10.8049 11.1541 11.1774 11.1541 11.8745V12.1532H8.60758V11.8746ZM8.54898 12.8889H11.1918V15.4202H8.54902L8.54898 12.8889Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_92_7087",
    x1: 0.234375,
    y1: 10,
    x2: 19.7656,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BC4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00AEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_92_7087",
    x1: 6.49184,
    y1: 6.35305,
    x2: 16.9743,
    y2: 16.8355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_92_7087"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/QuestionMark.ded7f225683ad1adc9d440164df99426.svg";
export { ForwardRef as ReactComponent };